export const isBrowser = typeof window !== "undefined";

export const makeQuery = (params) => {
  return Object.entries(params)
    .reduce((prev, [key, value]) => {
      const field = `${key}=${
        typeof value === "object" ? value.join(",") : value
      }`;
      return [...prev, field];
    }, [])
    .join("&");
};
